import { useMemo } from 'react';
import { ABTests } from '@fiverr-private/fiverr_context';

export const CONTROL_GROUP = 1;

export const useExperiment = (abTests: ABTests, groupNumber: number, experimentId?: number) => {
    if (!experimentId) {
        return { isInGroup: false };
    }

    const group = Number(abTests[experimentId]);

    return useMemo(() => ({ isInGroup: group === groupNumber }), [group, groupNumber]);
};
